import React from 'react';
import { RenderElementProps } from 'slate-react';
import { Image } from './Elements';

// Editor renders Slate elements in the following way:
export const Element = ({
	element,
	attributes,
	children,
}: RenderElementProps) => {
	switch (element.type) {
		case 'heading1':
			return <h1 {...attributes}>{children}</h1>;
		case 'heading2':
			return <h2 {...attributes}>{children}</h2>;
		case 'heading3':
			return <h3 {...attributes}>{children}</h3>;
		case 'heading4':
			return <h4 {...attributes}>{children}</h4>;
		case 'heading5':
			return <h5 {...attributes}>{children}</h5>;
		case 'heading6':
			return <h6 {...attributes}>{children}</h6>;
		case 'bulleted-list':
			return <ul {...attributes}>{children}</ul>;
		case 'numbered-list':
			return <ol {...attributes}>{children}</ol>;
		case 'list-item':
			return <li {...attributes}>{children}</li>;
		case 'link':
			return (
				<a
					{...attributes}
					href={element.href}
					target='_blank'
					rel='noopener noreferrer'
				>
					{children}
				</a>
			);
		case 'image':
			// Children must be rendered, even in void elements
			return (
				<Image attributes={attributes} element={element}>
					{children}
				</Image>
			);
		case 'pre':
			return <pre {...attributes}>{children}</pre>;
		case 'ejs-placeholder':
			return <span {...attributes}>{children}</span>;
		case 'ejs-button': // EJS buttons should not be inline
		case 'paragraph':
			return <p {...attributes}>{children}</p>;
		default:
			// Warning in case we forget to add renderer here
			return <span>Error: Add element renderer to Elements.tsx</span>;
	}
};
